import React from 'react';

import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import { useTranslation } from 'react-i18next';
import HeaderBlock from "../Blocks/HeaderBlock";

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export default function FormDialog({ clone, basket, open, setOpen, handleClickOpen, handleClose, titleDialog, textDialog, labelDialog, inputState, setInputState, onSubmit }) {

    const {t} = useTranslation();

    return (
        <React.Fragment>
            <Dialog
                open={open}
                onClose={handleClose}
                fullWidth={true}
                TransitionComponent={Transition}
                sx={{ zIndex: "13300 !important" }}
            >
                <DialogTitle>
                    <HeaderBlock>
                        {titleDialog}
                    </HeaderBlock>
                </DialogTitle>
                <DialogContent>
                    <div className="p-2 mt-1">
                        <DialogContentText>
                            {textDialog}
                        </DialogContentText>
                        <TextField
                            required
                            label={labelDialog}
                            type="text"
                            fullWidth
                            onChange={(e) => setInputState(e.target.value)}
                            autofill="disabled"
                        />
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>{t('cancel')}</Button>
                    <Button onClick={() => onSubmit(basket, inputState)}>{t('save')}</Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
}